// Polyfills & friends
import 'core-js';
import 'isomorphic-fetch';

// Libraries.
import '@/assets/scss/app.scss';

import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';
import vClickOutside from 'v-click-outside';
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css';
import { Validator } from 'vee-validate';
import PhoneNumber from 'awesome-phonenumber';
import VScrollLock from 'v-scroll-lock';

import Vue from 'vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

// Components.
import App from './App.vue';
import VueApollo from 'vue-apollo';

Vue.use(BootstrapVue);
Vue.use(ElementUI, { locale });
Vue.use(vClickOutside);
Vue.use(VueCroppie);
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
Vue.use(VueApollo);
Vue.use(VScrollLock);
// tslint:disable-next-line
Vue.use(require('vue-moment'));


// TODO : custom validators should probably not live inside `main.ts`
Validator.extend('phone_number', {
    getMessage: (field) => `${field} is not a valid phone number`,
    validate(value) {
        return new Promise((resolve) => {
            const phone = new PhoneNumber(value, 'US');
            resolve({ valid: phone.isValid() });
        });
    },
});

Validator.extend('jsonRequired', {
  getMessage: (field) => `${field} is required.`,
  validate(value) {
    return new Promise((resolve) => {
      let data;

      try {
        data = JSON.parse(value);
      } catch (e) {
        return resolve({valid: false});
      }

      if (data === null || data === undefined) {
        return resolve({valid: false});
      }

      if (data.length !== undefined) {
        return resolve({valid: data.length !== 0});
      } else {
        return resolve({valid: !!data});
      }
    });
  },
});


Vue.config.productionTip = false;

let environmentConfigPromise;

function configureApp() {
  environmentConfigPromise = fetch('/env_vars.json', {
    method: 'GET',
    mode: 'no-cors',
  })
  .then((response) => {
    if (response.ok) {
      return response.json();
    }
    console.error('response not ok');
    return Promise.reject(response.text());
  })
  .catch((error) => {
    console.error('Failed to load env_vars: ', error);
  });
}



function runApp() {
  new Vue({
      router,
      store,
      render: (h) => h(App),
  }).$mount('#app');
}

configureApp();
environmentConfigPromise.then((config) => {
  // @ts-ignore
  window.__env = config;
  runApp();
});

